/*
    应用根组件
*/
import React,{Component} from 'react'
import {BrowserRouter ,Switch,Router,Route,Redirect} from 'react-router-dom'
import Main from './pages/main/main'
import Login from './pages/login/login'
import './assets/css/main.less'
import MobileUpload from './pages/order-info/mobile-upload'
import authorizeRoute from "./components/authorize/authorizeRoute";
import SubscribeList from './pages/mobile/subscribe-list'
import CompanyBindOpt from './pages/mobile/company-bind-opt'
import history from './utills/history';

const RouteHoc = authorizeRoute(Route)
class App extends Component {
    render () {
        return (
            <Router history={history}>
                <Switch>
                    <RouteHoc path='/mobileup/:orderId' component={MobileUpload}/>
                    <Route path='/sub' component={SubscribeList}/>
                    <Route path='/companyBindOpt' component={CompanyBindOpt}/>
                    <Route path='/login' component={Login}/>
                    <RouteHoc path='/' component={Main}/>
                </Switch>
            </Router>
        )
    }
}
export default App